import StatusCard from "../../../components/StatusCard";
import { Instructor } from "@features/events/types";
import { StatusEntityType } from "@features/events/types";

interface InstructorStatusCardProps {
  instructorData: Partial<Instructor>;
  onDataChange: (updates: Partial<Instructor>) => void;
}

export default function InstructorStatusCard({
  instructorData,
  onDataChange,
}: InstructorStatusCardProps) {
  return (
    <StatusCard
      entityType={StatusEntityType.INSTRUCTOR}
      featured={instructorData.featured ?? null}
      verified={instructorData.verified ?? false}
      visibility={instructorData.visibility ?? 0}
      onDataChange={onDataChange}
    />
  );
}
